import { TextField } from '@tsp-ui/core/components';

import styles from './LoanProgramDetailsFields.module.scss';
import { LoanProgramFormValues } from './LoanProgramForm';


export function LoanProgramDetailsFields() {
    return (
        <>
            <TextField<LoanProgramFormValues>
                name="loanProgram.name"
                label="Program name"
                className={styles.fullWidth}
                required
            />

            <TextField<LoanProgramFormValues>
                name="loanProgram.description"
                label="Description"
                className={styles.fullWidth}
                required
                multiline
                maxRows={6}
            />
        </>
    );
}
